'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _draftJs = require('draft-js');

var _lodash = require('lodash');

exports.default = function (plugins) {
    return new _draftJs.CompositeDecorator((0, _lodash.flatMap)(plugins, function (plugin) {
        return plugin.decorators || [];
    }));
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/createCompositeDecorator.js
// module id = 1727
// module chunks = 0